export default __webpack_public_path__ + "static/media/club2.082c019e.webp";